export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY
export const mapCompanyAccounts: { [key: string]: any } = {
    'CONG_TY_SANN': 'CÔNG TY SANN',
    'CONG_TY_ZYNET': 'CÔNG TY ZYNET',
    'aff_sann': 'AFF SANN',
    'aff_zynet': 'AFF ZYNET',
}
export const mapSourcePackageDataSponsor: Record<string, string> = {
    'DataSponsor': 'Đại trà',
    'Affapi': 'Upgrade',
    'TDMSource': 'Thủ đô',
    'TV360Viettel': 'TV360',
    'TKG': 'TKG',
}
export const serviceCode = {
    VDS_MOBI_PHONE_KEY: "DATAMB", // network mobi phone
    VDS_VINA_PHONE_KEY: "DATAVN", // network Vina phone
    VDS_VIETTEL_KEY: "DATAVTKPP", // network Viettel
    IRIS_MOBIFONE_KEY: "DATA_MOBIFONE",
    IRIS_VINAPHONE_KEY: "DATA_VINAPHONE",
    IRIS_VIETTEL_KEY: "DATA_VIETTEL",
}
export const mapSourceProviders: Record<string, string> = {
    'data_sponsor': 'DataSponsor',
    'ds_postpaid': 'Ds PostPaid',
    'vds': 'Vds',
    'iris': 'IRIS',
}
export const mapServiceCode: Record<string, string> = {
    'DATAVTKPP': 'Nhà mạng Viettel',
    'DATAVN': 'Nhà mạng Vinaphone',
    'DATAMB': 'Nhà mạng Mobiphone',
    'DATA_VIETTEL': 'Nhà mạng Viettel',
    'DATA_VINAPHONE': 'Nhà mạng Vinaphone',
    'DATA_MOBIFONE': 'Nhà mạng Mobifone',
}
export const mapGroupCode: Record<string, string> = {
    '1': 'Sponsor trong nước',
    '2': 'Sponsor quốc tế',
    '3': 'Upgrade',
    '4': 'Sponsor cho thuê bao trả trước',
}

export const VIETTEL_TT = 'Viettel TT'

export const mapProviderDisplay: Record<string, string> = {
    'data_sponsor': VIETTEL_TT,
    'ds_postpaid': VIETTEL_TT,
    'vds': 'VDS',
    'iris': 'IRIS',
}

export const TRANSACTIONTYE_REGADDON = "REG_ADD_ON"
export const TRANSACTIONTYE_REGADDON_UPGRADE = "REG_ADD_ON_UPGRADE"
export const TRANSACTIONTYE_REGISTERCOMBO = "REGISTER_COMBO"
export const TRANSACTIONTYE_REGISTERCOMBOPROMOTION = "REGISTER_COMBO_PROMOTION"
export const TRANSACTIONTYE_REGISTERSERVICE = "REGISTER_SERVICE"

export enum ServiceCodeMaintain {
    TOP_UP = 'SERVICE_CODE_MAINTAIN_TOP_UP',
    PIN_CODE = 'SERVICE_CODE_MAINTAIN_PIN_CODE',
    DATA_CODE = 'SERVICE_CODE_MAINTAIN_DATA_CODE',
    DATA_SPONSOR = 'SERVICE_CODE_MAINTAIN_DATA_SPONSOR',
    TKG = 'SERVICE_CODE_MAINTAIN_TKG'
}

export enum ScopeMaintain {
    GLOBAL = 'SCOPE_MAINTAIN_GLOBAL',
    SERVICE = 'SCOPE_MAINTAIN_SERVICE',
    PARTNER = 'SCOPE_MAINTAIN_PARTNER',
    PACKAGE = 'SCOPE_MAINTAIN_PACKAGE'
}

export const mapMantenanceScope: Record<ScopeMaintain, string> = {
    [ScopeMaintain.GLOBAL]: 'Toàn hệ thống',
    [ScopeMaintain.SERVICE]: 'Dịch vụ',
    [ScopeMaintain.PARTNER]: 'Đối tác',
    [ScopeMaintain.PACKAGE]: 'Gói',
}

export const VDS_PROVIDER = 'vds'
export const IRIS_PROVIDER = 'iris'
export const DATA_SPONSOR_PROVIDER = 'data_sponsor'